var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-mobile-full-screen-container", [
    _c(
      "div",
      { staticClass: "w100" },
      [
        _c(
          "w-breadcrumb",
          { attrs: { crumbs: _vm.path } },
          [_c("w-spacer")],
          1
        ),
        _c(
          "w-scroll-view",
          { attrs: { tag: "w-container" } },
          [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { sm: "12", md: "6" } },
                  [
                    _c(
                      "w-card",
                      [
                        _c("w-card-title", [
                          _vm._v(_vm._s(_vm.$ct("title-add"))),
                        ]),
                        _c(
                          "w-card-content",
                          [
                            _c("w-info", {
                              attrs: {
                                text: _vm.$ct("info"),
                                "ico-lib": "fas",
                                ico: "info-circle",
                              },
                            }),
                            _c(
                              "w-card",
                              { staticClass: "mt" },
                              [
                                _vm.config && _vm.config.Displays.length
                                  ? _c(
                                      "w-list",
                                      _vm._l(
                                        _vm.config.Displays,
                                        function (display) {
                                          return _c(
                                            "w-list-item",
                                            { key: display.uuid },
                                            [
                                              _c(
                                                "w-list-item-icon",
                                                [
                                                  _c("w-fa", {
                                                    attrs: {
                                                      icon: "cash-register",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("w-list-item-text", [
                                                _vm._v(_vm._s(display.name)),
                                              ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "w-list",
                                          [
                                            _c(
                                              "w-list-item",
                                              [
                                                _c("w-list-item-text", [
                                                  _vm._v(
                                                    _vm._s(_vm.$ct("empty"))
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c("w-input", {
                              staticClass: "mt",
                              attrs: { fancy: "", label: _vm.$ct("name") },
                              model: {
                                value: _vm.name,
                                callback: function ($$v) {
                                  _vm.name = $$v
                                },
                                expression: "name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-card-actions",
                          [
                            _c("w-spacer"),
                            _vm.$wf.isMdUp
                              ? _c(
                                  "w-button",
                                  {
                                    attrs: { disabled: _vm.name == "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.save()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.add")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { sm: "12", md: "6" } },
                  [
                    _c(
                      "w-card",
                      [
                        _c("w-card-title", [
                          _vm._v(_vm._s(_vm.$ct("title-connect"))),
                        ]),
                        _c(
                          "w-card-content",
                          [
                            _c("w-info", {
                              attrs: {
                                text: _vm.$ct("info-connect"),
                                "ico-lib": "fas",
                                ico: "info-circle",
                              },
                            }),
                            _c("w-select", {
                              staticClass: "mt",
                              attrs: {
                                items: _vm.displays,
                                fancy: "",
                                label: _vm.$ct("connected-display"),
                              },
                              model: {
                                value: _vm.connectedDisplay,
                                callback: function ($$v) {
                                  _vm.connectedDisplay = $$v
                                },
                                expression: "connectedDisplay",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-card-actions",
                          [
                            _vm.cashierSettings.ConnectedDisplay != ""
                              ? _c(
                                  "w-button",
                                  {
                                    staticClass: "mr",
                                    attrs: { to: "/cashier-display" },
                                  },
                                  [_vm._v(_vm._s(_vm.$ct("show-on-display")))]
                                )
                              : _vm._e(),
                            _c("w-spacer"),
                            _vm.$wf.isMdUp
                              ? _c(
                                  "w-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.connect()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.save")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-card",
                      { staticClass: "mt" },
                      [
                        _c("w-card-title", [
                          _vm._v(_vm._s(_vm.$ct("common.settings"))),
                        ]),
                        _c(
                          "w-card-content",
                          [
                            _c("app-sale-type-select", {
                              attrs: {
                                "ignored-type-ids": [10],
                                label: _vm.$ct("type-choose"),
                                "contact-group-id": 1,
                                "use-id": "",
                                fancy: "",
                              },
                              model: {
                                value: _vm.cashierSettings.DefaultSaleType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cashierSettings,
                                    "DefaultSaleType",
                                    $$v
                                  )
                                },
                                expression: "cashierSettings.DefaultSaleType",
                              },
                            }),
                            _c("w-input-number", {
                              staticClass: "mt",
                              attrs: {
                                fancy: "",
                                label: _vm.$ct("cashier-start-amount"),
                                decimals: "2",
                              },
                              model: {
                                value: _vm.cashierSettings.DefaultStartAmount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cashierSettings,
                                    "DefaultStartAmount",
                                    $$v
                                  )
                                },
                                expression:
                                  "cashierSettings.DefaultStartAmount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-card-actions",
                          [
                            _c("w-spacer"),
                            _vm.$wf.isMdUp
                              ? _c(
                                  "w-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveSettings()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.save")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }